let ajax_complete_handler = async (jqXHR, $form, options = {}) => {
    let response;

    if (jqXHR.hasOwnProperty('responseJSON')) {
        response = jqXHR.responseJSON;
    } else {
        try {
            response = JSON.parse(jqXHR.responseText);
        } catch (e) {
            return false;
        }
    }

    // Validation Error
    if (jqXHR.status === 422 && $form) {
        try {
            let errorsCount = 0;
            const errorsToDisplay = {};
            const unmappedErrors = {};

            for (const key in response.errors) {
                if (!response.errors.hasOwnProperty(key)) continue;

                const messages = response.errors[key];
                let targetField = null;

                // Check for array-style input
                if ($form.find(`[name="${key}[]"]`).length) {
                    targetField = `${key}[]`;
                }
                // Check for plain input
                else if ($form.find(`[name="${key}"]`).length) {
                    targetField = key;
                }

                if (targetField) {
                    errorsToDisplay[targetField] = messages;
                    errorsCount++;
                } else {
                    unmappedErrors[key] = messages;
                    console.warn("Validation error for missing field:", key, messages);
                }
            }

            // Show field-level errors for matched inputs
            if (Object.keys(errorsToDisplay).length > 0) {
                $form.validate().showErrors(errorsToDisplay);
            }

            // Show toast for unmapped errors
            if (Object.keys(unmappedErrors).length > 0) {
                for (const key in unmappedErrors) {
                    if (!unmappedErrors.hasOwnProperty(key)) continue;
                    try {
                        window.Smart.utils.process_actions([{
                            name: 'toast',
                            data: { type: 'error', title: window.Smart.lang.invalid_title, message: unmappedErrors[key].join("<br>") }
                        }]);
                    } catch (e) {
                        console.warn("Failed to display unmapped validation error:", unmappedErrors[key]);
                    }
                }
            }

            // Summary toast for matched errors
            if (errorsCount > 0) {
                let message =
                errorsCount === 1
                ? window.Smart.lang.invalid_single
                : window.Smart.lang.invalid_multiple.replace("%count%", errorsCount);

                window.Smart.utils.process_actions([{
                    name: 'toast',
                    data: { type: 'error', title: window.Smart.lang.invalid_title, message }
                }]);
            }
        } catch (e) {
            console.error("Validation error handler failed:", e);
        }
    }

    if (jqXHR.status === 429) {
        let message = response.message || "Too many requests. Please try again later.";
        window.Smart.utils.process_actions([
            {
                name: "toast",
                data: {
                    type: "error",
                    title: "Error",
                    message
                }
            }
        ]);
        return false;
    }

    if (jqXHR.status === 403) {
        if (response.hasOwnProperty('reason')) {
            if (response.reason === 'access_denied') {
                window.Smart.utils.process_actions([
                    {
                        name: 'toast',
                        data: {
                            type: 'error',
                            title: response.message,
                            message: 'You are not allowed to perform this action.',
                        }
                    }
                ])
            }

            if (response.reason === 'ip_blocked') {
                window.Smart.utils.process_actions([
                    {
                        name: 'toast',
                        data: {
                            type: 'error',
                            title: response.message,
                            message: 'Your IP address has been blocked.',
                        }
                    }
                ])
            }
        }
    }

    // Actions from server
    if (response.hasOwnProperty('actions')) {
        let actionsToRun = response.actions;

        // ✅ If the request was from offline queue, skip redirect actions
        if (options.isFromQueue) {
            actionsToRun = actionsToRun.filter(action => action.name !== 'redirect');
        }

        window.Smart.utils.process_actions(actionsToRun);
    }

    window.Smart.initPlugins();

    return response;
}

export default ajax_complete_handler;
